import React, {useState} from 'react';
import styles from "./RecoveryPasswordForm.module.css";
import Input from "../../../components/Utils/Inputs/Input/Input";
import Buttons, {EnumButtonType, EnumColors} from "../../../components/Utils/Buttons/Buttons/Buttons";
import {toast} from "react-toastify";
import {authApi} from "../../../api/authApi";
import {useAppDispatch} from "../../../hooks/redux";
import {authSlice} from "../../../store/reducers/AuthSlice";
import {getTextByLanguage} from "../../../enums/utils/getTextByLanguage";
import {UXToast} from "../../../enums/UXText/UXToast";
import {useNavigate} from "react-router-dom";

interface IProps {
    recoveryKey: string}

const RecoveryPasswordForm = ({recoveryKey}: IProps) => {

    const [password, setPassword] = useState<string>('')
    const [passwordRepeat, setPasswordRepeat] = useState<string>('')
    const [isFetching, setIsFetching] = useState<boolean>(false)

    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    const changePasswordHandler = () => {
        setIsFetching(true)
        if (password.length > 3 && password === passwordRepeat) {
            authApi.changePasswordWithRecoveryKey({password, recoveryKey}).then(data => {

                const profileData = data.data

                if (profileData.user.isActivated) {
                    localStorage.setItem('token', profileData.accessToken)
                    dispatch(authSlice.actions.setIsAuth(true))
                    dispatch(authSlice.actions.setProfile(profileData.user))
                    toast.success('Вы успешно сменили пароль и авторизовались в свою учетную запись')
                    navigate('/profile')
                }
                setIsFetching(false)
            }).catch(error => {
                console.log(error)
                setIsFetching(false)
            })
        } else {
            toast.info('Пароли не совпадают')
            setIsFetching(false)
        }
    }


    return (
        <>
            <div className={styles.inputsWrapper}>
                <div className={styles.inputWrapper}>
                    <label htmlFor="passwordRecoveryInput">
                        Введите новый пароль
                    </label>
                    <Input type={'password'} id={'passwordRecoveryInput'} onChange={(e) => setPassword(String(e.target.value))} className={styles.input}/>
                </div>
                <div className={styles.inputWrapper}>
                    <label htmlFor="repeatPasswordRecoveryInput">
                        Повторите пароль
                    </label>
                    <Input type={'password'} id={'repeatPasswordRecoveryInput'} onChange={(e) => setPasswordRepeat(String(e.target.value))} className={styles.input}/>
                </div>
            </div>

            <Buttons
                className={styles.button}
                onClick={changePasswordHandler}
                color={EnumColors.white}
                type={EnumButtonType.filled}
                loading={isFetching}
                disabled={isFetching}>Установить новый пароль</Buttons>
        </>


    );
};

export default RecoveryPasswordForm;